export const checkResponseError = (res) => {
  if (res.ok) {
    return
  }

  const err = new Error(`HTTP status code: ${res.status}`)
  err.response = res
  err.status = res.status
  throw err
}
